import { Component} from '@angular/core';
import {ModalController, NavController, NavParams, ViewController} from 'ionic-angular';
import { ProfilePage } from '../../profile/profile';
import { MeetteamProvider } from '../../../../providers/meetteam/meetteam';
import { AuthProvider } from '../../../../providers/auth/auth';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import {CupertinoPane} from "cupertino-pane";



@Component({
    selector: 'page-meet-details',
    templateUrl: 'meet-details.html',
})
export class MeetteamDetailsPage {

    messagesSection;

    meetId: string;
    eventInfo: any = {};
    messages: any[] = [];
    newMessage: string = null;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public meetProvider: MeetteamProvider,
                public viewCtrl: ViewController,
                private authProvider: AuthProvider,
                private iab: InAppBrowser,
                private modalCtrl: ModalController) {
        this.meetId = this.navParams.get("meetId");
    }
    currUserId: string = this.authProvider.user.user_id;
    currUserAvatar: string;


    ngOnInit() {
        this.meetProvider.get(this.meetId).subscribe((res) => {
            if (res.success) {
                this.eventInfo = res.data;
                this.eventInfo.date = this.eventInfo.date.split('/').reverse().join('-') // Converts mm/dd/yyyy to yyyy-dd-mmm for date pipe :)
                // Get all messages and format
                this.eventInfo.Messages.forEach(message => {
                    this.messages.push({
                        isMe: message.author_id == this.currUserId ? true : false,
                        type: 'text',
                        name: message.User.first_name + ' ' + message.User.last_name,
                        body: message.content,
                        timestamp: message.date
                    })
                });

                this.messages = this.messages.reverse();

                // Converts avatar
                this.eventInfo.Users.forEach(user => {
                    if(user.User.id == this.currUserId){
                        this.currUserAvatar = user.User.avatar_content;
                    }
                });
            }
        })
    }


    dismiss() {
        this.viewCtrl.dismiss();
    }

    goToProfile(userId) {
      this.modalCtrl.create(ProfilePage, {userId : userId}).present().then(() => {});

    }

    openZoomMeet(url: string) {
        const browser = this.iab.create(url);
    }

    // Decoding image buffer
    ab2str(arraybuffer) {
        return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
    }

    sendMessage(){
        if(this.newMessage !== null){
            this.meetProvider.commentCreate({lunchroulette_id : this.meetId, content : this.newMessage}).subscribe((res) =>{
                if(res.success){
                    this.messages.push(
                        {
                            isMe: true,
                            type: 'text',
                            body: this.newMessage,
                            timestamp : new Date()
                        }
                    )
                    this.newMessage = null;
                }
            })
        }
    }


  openMessages() {
    this.messagesSection = new CupertinoPane(
      '.cupertino-pane-meeting-messages', // Pane container selector
      {
        parentElement: 'body', // Parent container
        breaks: {
          middle: { enabled: true, height: 1000, bounce: true },
        },
        bottomClose: true,
        buttonDestroy: false,
        backdrop: true,
        backdropOpacity: 0.8,
        onBackdropTap: () => {
          this.messagesSection.hide();

          setTimeout(() => {
            this.messagesSection.destroy()
          }, 200);
        },
      }
    );
    this.messagesSection.present({animate: true});
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/lunchroulette/meet-details/meet-details.ts